
    var riot = require('riot')
    //src: starling/src/tags/comments/comment-menu.html
riot.tag2('comment-menu',
  '<ul class="floating-menu_list"> <li if="{isOwner()}" class="floating-menu_item" onclick="{startEdit}" data-track="Comment Menu" data-track-action="Edit-Comment" data-track-label="Comment"> <svg class="floating-menu_icon"> <use xlink:href="#edit-icon"></use> </svg> <span class="floating-menu_label">Edit comment</span> </li> <li if="{comment && !comment.parentId && !comment.isResolved()}" class="floating-menu_item" onclick="{resolveComment}" data-track="Comment Menu" data-track-action="Resolve-Comment" data-track-label="Comment"> <svg class="floating-menu_icon"> <use xlink:href="#check-circle-outline-icon"></use> </svg> <span class="floating-menu_label">Resolve comment</span> </li> <li if="{comment && !comment.parentId && comment.isResolved()}" class="floating-menu_item floating-menu_item--iconless" onclick="{unresolveComment}" data-track="Comment Menu" data-track-action="Unresolve-Comment" data-track-label="Comment"> <span class="floating-menu_label">Re-open comment</span> </li> <li if="{isOwner() || (comment && !comment.parentId) && appUI.isMapOwner()}" class="floating-menu_divider"></li> <li if="{isOwner() || appUI.isMapOwner()}" class="floating-menu_item" onclick="{deleteComment}" data-track="Comment Menu" data-track-action="Delete-Comment" data-track-label="Comment"> <svg class="floating-menu_icon"> <use xlink:href="#delete-icon"></use> </svg> <span class="floating-menu_label">Delete comment</span> </li> </ul>',
  '',
  'show="{summoned}" class="floating-menu floating-menu--fixed floating-menu--small {position && \'floating-menu--\' + position}"', function(opts) {
'use strict';

var _this = this;

var _eventTracking = require('lib/event-tracking');

var _eventTracking2 = _interopRequireDefault(_eventTracking);

var _appUi = require('lib/app-ui');

var _menuUi = require('lib/menu-ui');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _opts = opts,
    canvas = _opts.canvas;

canvas.commentMenuTag = this;

this.positionSelf = _menuUi.mui.positionSelf.bind(this);

this.on('mount', function () {
  $(_this.root).on('mousedown touchstart pointerdown', function (event) {
    return event.stopImmediatePropagation();
  });
});

this.on('updated', _eventTracking2.default.listen(this.root));

this.startEdit = function () {
  var comment = _this.comment;
  var id = comment.id,
      type = comment.type;

  var commentTag = null;

  if (type === 'sidebar') {
    commentTag = canvas.commentTagsInSidebar[id];
  } else {
    commentTag = canvas.commentTags[id];
  }

  if (commentTag) commentTag.startEdit();

  _this.hide();
  _eventTracking2.default.track({
    category: 'Comment-Action',
    action: 'Comment-Edit',
    label: 'Start-Comment-Edit'
  });
};

this.deleteComment = function () {
  commentsUI.deleteComment(_this.comment.id);
  _this.hide();
  _eventTracking2.default.track({
    category: 'Comment-Action',
    action: 'Comment-Delete',
    label: 'Comment-Delete'
  });
};

this.toggle = function (_ref) {
  var comment = _ref.comment,
      referenceEl = _ref.referenceEl,
      position = _ref.position;

  if (_this.summoned && _this.comment === comment && _this.referenceEl === referenceEl) {
    _this.hide();
  } else {
    _this.summon({ comment: comment, referenceEl: referenceEl, position: position });
  }
};

this.summon = function (_ref2) {
  var comment = _ref2.comment,
      referenceEl = _ref2.referenceEl,
      position = _ref2.position;

  Object.assign(_this, { comment: comment, referenceEl: referenceEl, position: position, summoned: true });

  _this.update();

  _this.positionSelf({
    referenceEl: referenceEl,
    selfEl: _this.root
  });
};

this.hide = function () {
  Object.assign(_this, { summoned: false, comment: null, referenceEl: null, position: null });
  _this.update();
};

this.resolveComment = function () {
  commentsUI.resolveComment(_this.comment.id);
  _this.hide();
  _eventTracking2.default.track({
    category: 'Comment-Action',
    action: 'Comment-Resolve',
    label: 'Comment-Resolve'
  });
};

this.unresolveComment = function () {
  commentsUI.unresolveComment(_this.comment.id);
  _this.hide();
  _eventTracking2.default.track({
    category: 'Comment-Action',
    action: 'Comment-Unresolve',
    label: 'Comment-Unresolve'
  });
};

this.isOwner = function () {
  var comment = _this.comment;

  return comment && commentsUI.isOwner(comment.id);
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('comment-menu')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/comments/comment-menu.html
// module id = 796
// module chunks = 0